import axios from 'domain/shared/services/axios';
// import { LeadAction } from '../types/lead-action';

export default class EngagementTypesService {
  public static async getAllEngagementTypes() {
    const { data } = await axios.get('/engagement-types');
    return data;
  }
}
